import { Attention, Success, InfoFilled } from '@yme/assets/icons';
import { AlertType } from './types';
export const getIconType = (type) => {
    switch (type) {
        case AlertType.SUCCESS:
            return Success;
        case AlertType.INFO:
            return InfoFilled;
        default:
            return Attention;
    }
};
